import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { PageLoaderFacade } from '@library/store/page-loader/page-loader.facade';
import { EditUserLocationComponent } from '@library/ui/views/edit-user-location/edit-user-location.component';
import { LangPipe } from '@library/utils/pipes/lang.pipe';
import { HeaderService } from '@library/utils/services/header.service';

@Component({
  selector: 'app-location-view',
  template: '<view-edit-user-location />',
  imports: [EditUserLocationComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocationViewComponent implements OnInit {
  constructor(
    private readonly pageLoaderFacade: PageLoaderFacade,
    private readonly header: HeaderService,
    private readonly langPipe: LangPipe,
    private readonly titleService: Title,
  ) {
  }

  ngOnInit(): void {
    this.pageLoaderFacade.handlePageLoader();
    this.header.push({
      title: this.langPipe.transform('common-app.__COM_SETTINGS_LOCATION'),
    });
    this.titleService.setTitle('Home advanced settings / Location');
  }
}
